export const SET_CART_INFO = 'SET_CART_INFO';
